/**
 * @module edition
 * @description Edition-based feature gating — shared types for API + Web
 */
export var Edition;
(function (Edition) {
    Edition["LITE"] = "lite";
    Edition["BUSINESS"] = "business";
    Edition["ENTERPRISE"] = "enterprise";
})(Edition || (Edition = {}));
/**
 * All controllable feature keys
 * Naming: {module}.{sub-feature}
 */
export const FEATURE_KEYS = {
    // Auth
    'auth.2fa': '雙重驗證',
    'auth.rbac': '角色權限管理',
    'auth.multi-user': '多帳號管理',
    'auth.device-binding': '裝置綁定',
    // Tournament
    'tournament.multi': '多場賽事同時進行',
    'tournament.template-custom': '自訂賽事模板',
    'tournament.icm': 'ICM 計算器',
    'tournament.payout-print': '獎金簽收單列印',
    'tournament.history-export': '歷史賽事匯出',
    // Blind Structure
    'blind.custom': '自訂盲注結構',
    'blind.import-export': '盲注結構匯入/匯出',
    // Display
    'display.multi-screen': '多螢幕管理',
    'display.layout-editor': '佈局編輯器',
    'display.branding': 'TV 品牌化',
    // Member
    'member.enabled': '會員系統',
    'member.import': '批次匯入',
    'member.qrcode': 'QR Code 報到',
    'member.points': '點數系統',
    // Accounting
    'accounting.enabled': '帳務系統',
    'accounting.pdf-report': 'PDF 報表',
    'accounting.email-send': '報表 Email 寄送',
    // Dealer & Floor
    'dealer.pwa': '荷官 PWA',
    'floor.console': '場管操作台',
    // i18n
    'i18n.switch': '語言切換',
    'i18n.custom-terms': '術語自訂',
    // Branding
    'branding.logo': '場館 LOGO',
    'branding.theme': '場館配色',
    // Voice is opt-in only; no edition enables it by default.
    'voice.enabled': '語音操作',
    // Advanced
    'report.advanced': '進階報表',
    'social.integration': '社群整合',
    'cloud.multi-venue': '雲端多場館',
};
/** Features enabled per edition */
const BUSINESS_FEATURES = [
    'auth.2fa',
    'auth.rbac',
    'auth.multi-user',
    'auth.device-binding',
    'tournament.multi',
    'tournament.template-custom',
    'tournament.icm',
    'tournament.payout-print',
    'tournament.history-export',
    'blind.custom',
    'blind.import-export',
    'display.multi-screen',
    'display.layout-editor',
    'display.branding',
    'member.enabled',
    'member.import',
    'member.points',
    'member.qrcode',
    'accounting.enabled',
    'accounting.pdf-report',
    'accounting.email-send',
    'dealer.pwa',
    'floor.console',
    'i18n.switch',
    'i18n.custom-terms',
    'branding.logo',
    'branding.theme',
    'report.advanced',
];
const ENTERPRISE_FEATURES = [
    ...BUSINESS_FEATURES,
    'social.integration',
    'cloud.multi-venue',
];
/**
 * Lite core features — tournament lifecycle + basic system settings.
 * Member, accounting, floor, RBAC, dealer are Business-only.
 */
const LITE_FEATURES = [
    'blind.custom',
    'tournament.template-custom',
    'tournament.icm',
    'tournament.payout-print',
    'display.layout-editor',
    'display.multi-screen',
    'i18n.switch',
    'i18n.custom-terms',
    'branding.logo',
    'branding.theme',
];
export const EDITION_FEATURES = {
    [Edition.LITE]: LITE_FEATURES,
    [Edition.BUSINESS]: BUSINESS_FEATURES,
    [Edition.ENTERPRISE]: ENTERPRISE_FEATURES,
};
/** Edition distinctions can pause without enabling opt-in features. */
export const UNIFIED_FEATURES = [...new Set(Object.values(EDITION_FEATURES).flat())];
//# sourceMappingURL=edition.js.map